import React, { Fragment, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import homeIcon from "../../assets/images/home_icon.png";
import dbIcon from "../../assets/images/dashbordIcon.svg";
import assetsIcon from "../../assets/images/assets_icon.png";
import aDIcon from "../../assets/images/AD_icon.svg";
import sBIcon from "../../assets/images/SB_icon.svg";
import inventoryIcon from "../../assets/images/inventory_icon.svg";
import templateIcon from "../../assets/images/template.svg";
import fisIcon from "../../assets/images/fis.png";
import config from "../../config"
import { getLocalStorageInfo } from "../../utils";
import { Tooltip } from "@material-ui/core";
import { smbcInstance } from ".";
import { globalGetService } from "../../utils/globalApiServices";
import { checkApiStatus, permissionCheckFnforCamo } from "../../utils";
export const MainNavLink = ({ match }) => {

	useEffect(() => {
		if (match?.url === "/configure/disclaimer" || match?.url === "/configure/llp" || match?.url === "/configure/engine"|| match?.url === "/configure/utilization-approval") {
			utilApprovalFlowApi()
		} else if (match?.url?.split("/")?.slice(3)?.join("/") === "utilization/list") {
			localStorage.setItem("utiFlow_approval", JSON.stringify(true))
		} else {
			localStorage.setItem("utiFlow_approval", JSON.stringify(false))
		}
	}, [])

	const utilApprovalFlowApi = () => {
		globalGetService(`camo/util_approval/lessor/`).then((response) => {
			if (checkApiStatus(response)) {
				localStorage.setItem("utiFlow_approval", JSON.stringify(response?.data?.utilization_approval));
			}
		});
	}
	return (
		<Fragment>
			<ul className="list-unstyled">
				{/* <li>
					<a href={config.domain.subDomian} target="_blank" >
						<img src={homeIcon} alt="Home" width="25" />
						<p>Home</p>
					</a>
				</li> */}
				{permissionCheckFnforCamo({ primaryKey: "asset_management", keyIndex: "R" }) ? <li>
					<Link className={match.path.includes("dashboard") ? "active" : ""} to="/dashboard" >
					<img src={homeIcon} alt="Home" width="25" />
					<p>Home</p>
					</Link>
				</li> : null}
				<li>
					<Link className={match.path === '/' || match.path.includes("list") ? "active" : ""} to="/assets-listing" >
						<img
							src="https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/asset_list_icon.png"
							alt="Assets"
							width="20"
						/>
						<p>Assets</p>
					</Link>
				</li>
				{permissionCheckFnforCamo({ primaryKey: "asset_management", keyIndex: "R" }) && <>
					<li>
						<Link className={match.path.includes("fleet/ad") ? "active" : ""} to="/fleet/ad" >
							<img src={aDIcon} alt="fleet/ad" width="20" />
							<p>Airworthiness Directives</p>
						</Link>
					</li>
					<li>
						<Link className={match.path.includes("fleet/sb") ? "active" : ""} to="/fleet/sb" >
							<img src={sBIcon} alt="fleet/sb" width="20" />
							<p>Service Bulletins</p>
						</Link>
					</li>
					<li>
						<Link className={match.path.includes("reports") ? "active" : ""} to="/reports/portfolio" >
							<img
								src="https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/report_icon.png"
								alt="reports"
								width="20"
							/>
							<p>Reports</p>
						</Link>
					</li>
					<li>
						<Link className={match.path.includes("configure") ? "active" : ""} to="/configure/disclaimer">
							<img
								src="https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/settings.png"
								alt="config"
								width="20"
							/>
							<p>Configure</p>
						</Link>
					</li>
					<li>
						<Link className={match.path.includes("camo/consignment") ? "active" : ""} to="/camo/consignment" >
							<img src={inventoryIcon} alt="camo/consignment" width="20" />
							<p>Consignment</p>
						</Link>
					</li>
					<li>
						<Link className={match.path.includes("camo/templates") ? "active" : ""} to="/camo/templates" >
							<img src={templateIcon} alt="camo/templates" width="20" />
							<p>Templates</p>
						</Link>
					</li>
					<li>
						<Link className={match.path.includes("camo/integration-audit") ? "active" : ""} to="/camo/integration-audit" >
							<img src={fisIcon} alt="camo/integration-audit" width="20" />
							<p>Audit History</p>
						</Link>
					</li>
				</>}
			</ul>
		</Fragment>
	);
};

export default withRouter(MainNavLink);
